export type UpcomingPatientAppointment = {
	appointmentId: number
	patientId: number
	locationId: number
	address: string
	startTimeUtc: string
	startTimeLocal: string
	duration: number
	types: string[]
	isConfirmed: boolean
	isConfirmable: boolean
	startTimeFormatted?: string
}

export type CreateAppointmentSchedulingLinkResponse = {
	schedulingURL: string
}

export type RescheduleAppointmentResponse = {
	rescheduleLinkUrl: string
}

export enum ScheduleHoldReason {
	NONE = 'NONE',
	VRDH_REQUIRED = 'VRDH_REQUIRED',
	AWAITING_RESULTS = 'AWAITING_RESULTS',
	AWAITING_MEDICAL_CLEARANCE = 'AWAITING_MEDICAL_CLEARANCE',
}

export enum VrdhCallReason {
	APPOINTMENT_RESULTS = 'APPOINTMENT_RESULTS',
	MEDICAL_CLEARANCE = 'MEDICAL_CLEARANCE',
}

export type ScheduleActionsResponse = {
	canScheduleAppointment: boolean
	nextAppointmentType?: string
	schedulingHoldReason: ScheduleHoldReason
	vrdhCallReason: VrdhCallReason
}

export type VrdhSchedulingSlot = {
	startTimeUtc: string
	vrdhId: number
}

export type VrdhSchedulingRequest = {
	startTimeUtc: string
	vrdhId: number
	vrdhCallReason?: string
}

export type VrdhReschedulingRequest = {
	startTimeUtc: string
	vrdhId: number
	rescheduledEventId?: string
	vrdhCallReason?: string
}

export type ScheduledVrdhCall = {
	id: number
	vrdhId: number
	patientId: number
	startTimeUtc: string
	endTimeUtc: string
	startTimeFormatted: string
	calendarEventId: string
	calendarEventStatus: string
	callReason: VrdhCallReason
}

export type AppointmentResultReportCondition = {
	title: string
	description: string
}

export type AppointmentResultReportNextSteps = {
	description: string
	title: string
}

export type AppointmentResultReportResponse = {
	isLocked: boolean
	results?: AppointmentResultReport
	appointmentId?: number
}

export type AppointmentResultReport = {
	canBookNextAppointment: boolean
	summary: string
	healthScore: number
	conditions: AppointmentResultReportCondition[]
	nextSteps: AppointmentResultReportNextSteps
	nextAppointmentType: string
}
